import { render, staticRenderFns } from "./addBigScreen.vue?vue&type=template&id=65d94ca6&scoped=true&"
import script from "./addBigScreen.vue?vue&type=script&lang=js&"
export * from "./addBigScreen.vue?vue&type=script&lang=js&"
import style0 from "./addBigScreen.vue?vue&type=style&index=0&id=65d94ca6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d94ca6",
  null
  
)

export default component.exports